// extracted by mini-css-extract-plugin
export var defaultWrapper = "_gs-3";
export var downloadButton = "_gs-4";
export var fileContainer = "_gs-9 _gs-7";
export var fileContainerBase = "_gs-7";
export var fileContainerFixedHeight = "_gs-8 _gs-7";
export var fileInfo = "_gs-5";
export var fileInfoWidthRestricted = "_gs-6";
export var fileType = "_gs-1";
export var fileTypeName = "_gs-2";
export var image = "_gs-0";
export var link = "_gs-b";
export var overflowEllipsis = "_gs-a";